import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIExampleContainer = _resolveComponent("UIExampleContainer")!

  return (_openBlock(), _createBlock(_component_UIExampleContainer, {
    componentId: 'HighlightedText',
    name: 'Highlighted Text',
    vueComponent: _ctx.vueComponent,
    vueCode: _ctx.vueCode,
    singleViewRouteName: 'uiComponentFullPage'
  }, null, 8, ["vueComponent", "vueCode"]))
}